<button class="btn btn-lg btn-primary btn-block mt-2 text-black" (click)="redirectToShibboleth()">
  <span aria-hidden="true" class="fas fa-sign-in-alt"></span> {{"login.form.shibboleth" | translate}}
</button>
